<template>
  <card>
    <template #header>
      <card-header>
        {{ $t("homes.percentageOfCompanyTechnology") }}
        <!-- <template #action>
          <el-link type="primary" :underline="false">
            {{ $t("global.more") }}
            <i class="el-icon-arrow-right" style="color:#999999;" />
          </el-link>
        </template>-->
      </card-header>
    </template>
    <div class="chart">
      <chart id="chart1" ref="companyChart" @chartClick="click" :options="options" />
    </div>
  </card>
</template>

<script>
import { percentageOfCompanyTechnologyArea } from "@/api/homes";

export default {
  components: {},
  mixins: [],
  props: {},
  data() {
    return {
      xAxis: [],
      Values: []
    };
  },
  computed: {
    lang() {
      return this.$store.state.app.language;
    },
    options() {
      return {
        color:['#EB7E65','#83D0EF','#A285D2','#FFAB67','#5B8FF9','#73DEB3','#7585A2','#F7C739','#92865D','#C6EBF8','#A5ADBE','#FBE5A2'],
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },
        legend: {
          orient: "vertical",
          left: 10,
          top: 0,
          bottom: 0,
          icon: "circle",
          textStyle: {
            color: "#999999"
          },
          data: this.xAxis
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: ["40%", "60%"],
            avoidLabelOverlap: true,
            center: ["78%", "50%"],
            data: this.Values,
            label: {
              formatter: "{c}"
            }
          }
        ]
      };
    }
  },
  watch: {
    lang() {
      this.loadData()
    }
  },
  created() {this.loadData()},
  mounted() {},
  destroyed() {},
  methods: {
    click(params) {
      this.$router.push({
        path: "/projectManagement/projectListView",
        query: { technicalArea: params.data.code }
      });
    },
    loadData() {
      percentageOfCompanyTechnologyArea().then(resp => {
        const data = resp.data;
        this.xAxis = data.names;
        this.Values = data.values;

        this.$refs.companyChart.setOption(this.options);
      });
    }
  }
};
</script>
<style  scoped>
.chart {
  height: 170px;
}
</style>
